var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "w-full" }, [
    _c(
      "div",
      { staticClass: "h-full w-full" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6",
          },
          [
            _c(
              "h1",
              {
                staticClass:
                  "mobileHeading sm:text-heading font-semibold font-outfit leading-10 sm:mt-4",
              },
              [_vm._v(" Your Weekly Scheduler ")]
            ),
            _c("UIButton", {
              staticClass: "ml-auto mt-3 sm:mt-0 font-outfit",
              attrs: {
                buttonText: "Go to Clients & All visits",
                variant: "black",
                size: "lg",
              },
              on: { click: _vm.toggle },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("ArrowIcon", { staticClass: "w-4 h-4" })]
                  },
                  proxy: true,
                },
                {
                  key: "hover-icon",
                  fn: function () {
                    return [_c("HoveredIcon", { staticClass: "w-3 h-3" })]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
        _c("div", { staticClass: "mb-6 flex flex-col gap-6" }, [
          _c(
            "div",
            {
              staticClass:
                "flex flex-wrap gap-4 justify-between custom-filter-area items-center",
            },
            [
              _c("div", { staticClass: "flex flex-wrap gap-4 flex-1" }, [
                _c(
                  "div",
                  { staticClass: "dropdown-holder" },
                  [
                    _c("DropdownFilter", {
                      attrs: {
                        withoutLoading: "",
                        placeholder: "Search by manager",
                        searchable: true,
                        multiple: true,
                        value: _vm.manager_option,
                        options: _vm.manager_options,
                      },
                      on: { search: _vm.setManagers, input: _vm.setManagers },
                    }),
                  ],
                  1
                ),
              ]),
              _c("UIButton", {
                staticClass: "ml-4 font-outfit",
                attrs: { buttonText: "Reset", variant: "outline", size: "lg" },
                on: { click: _vm.handleFilterReset },
              }),
            ],
            1
          ),
        ]),
        _c(
          "LoadingOverlay",
          {
            attrs: {
              loading: _vm.isLoaded,
              hasData: _vm.isTimesheetEmpty,
              customPlaceholderMessage: !_vm.isTimesheetEmpty
                ? "There are no visits"
                : "Information is currently unavailable",
            },
            scopedSlots: _vm._u([
              {
                key: "empty_placeholder",
                fn: function () {
                  return [
                    _c("EmptyListImageProjects", { staticClass: "emptyStyle" }),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _c(
              "div",
              {
                staticClass: "h-auto",
                class: _vm.weekDisable
                  ? ` p-5 timesheet_container timesheet_disable`
                  : ` p-5 timesheet_container`,
              },
              [
                _c("vue-cal", {
                  ref: "vuecalRef",
                  attrs: {
                    "time-from": 7 * 60,
                    "time-to": 25 * 60,
                    events: _vm.events,
                    "time-cell-height": 120,
                    "twelve-hour": true,
                    "selected-date": _vm.currentDate,
                    id: "vuecal",
                    "hide-view-selector": "",
                    "disable-views": ["years", "year", "month", "day"],
                    "min-event-width": 50,
                    allDayBarHeight: "50px",
                    editableEvents: false,
                    draggable: false,
                    onEventClick: _vm.onEventClick,
                    resizable: false,
                    overlap: false,
                  },
                  on: {
                    ready: function ($event) {
                      return _vm.getWeek($event)
                    },
                    "view-change": function ($event) {
                      return _vm.getWeek($event)
                    },
                    "cell-click": _vm.disableCellClick,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function ({ view }) {
                        return [
                          view.id === "week"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "font-outfit font-semibold text-xl w-full justify-between",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.dateRange(view)) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "weekday-heading",
                      fn: function ({ heading }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-outfit flex flex-col justify-center font-medium text-xl h-18",
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(heading.date.format("DD"))),
                              ]),
                              _c("span", { staticClass: "weekday_name" }, [
                                _vm._v(_vm._s(heading.label.substring(0, 3))),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "time-cell",
                      fn: function ({ hours, minutes }) {
                        return [
                          _c(
                            "div",
                            {
                              class: {
                                "vuecal__time-cell-line": false,
                                hours: !minutes,
                              },
                            },
                            [
                              !minutes
                                ? _c(
                                    "strong",
                                    { staticStyle: { "font-size": "15px" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            hours % 12 === 0 ? 12 : hours % 12
                                          ) +
                                          " "
                                      ),
                                      hours < 12
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "15px",
                                              },
                                            },
                                            [_vm._v("AM")]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "15px",
                                              },
                                            },
                                            [_vm._v("PM")]
                                          ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { "font-size": "11px" } },
                                    [_vm._v(_vm._s(minutes))]
                                  ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell-content",
                      fn: function ({ view, events }) {
                        return [
                          ["week", "day"].includes(view.id) && !events.length
                            ? _c("span", { staticClass: "vuecal__no-event" })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "event",
                      fn: function ({ event }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "vuecal__event",
                              class: event.class,
                              style: {
                                width: event.style.width,
                                left: event.style.left,
                                position: "absolute",
                              },
                            },
                            [
                              !event.isPlaceholder
                                ? _c(
                                    "div",
                                    { staticClass: "vuecal__event-time" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "timer_cell_parent" },
                                        [
                                          event.style.width !== `100%` ||
                                          event.isLessThanHour
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass: "h-4 mb-1",
                                                      attrs: {
                                                        title: "",
                                                        variant:
                                                          _vm.TooltipVariants
                                                            .WHITE,
                                                        placement: "top",
                                                        tooltipPopOverClass:
                                                          "adjustTop",
                                                        tooltipClasses:
                                                          "w-auto p-2 customPad",
                                                        trigger: "click",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "content",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "vuecal__event-title mb-4 font-normal custom-prefix",
                                                                    class:
                                                                      event.class,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          event.status
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "flex flex-col gap-2 vuecal__event-content",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "flex flex-row items-center font-outfit text-xs font-normal",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "ProfileGray",
                                                                          {
                                                                            staticClass:
                                                                              "w-3 h-3",
                                                                          }
                                                                        ),
                                                                        event.title
                                                                          ? _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "text-notification-blue ml-3 font-normal",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      event.title
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "ml-3",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "n/a"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c("div", [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "flex flex-row items-center",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "CalendarIcon",
                                                                            {
                                                                              staticClass:
                                                                                "h-3 w-3",
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "text-xs font-normal leading-normal text-primary-black ml-3",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.createdAt(
                                                                                      event
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "flex flex-row items-center font-outfit text-xs leading-normal text-primary-black",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "ClockIcon",
                                                                            {
                                                                              staticClass:
                                                                                "w-3 h-3",
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "ml-3 text-xs font-normal",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .$moment(
                                                                                        event.start
                                                                                      )
                                                                                      .format(
                                                                                        "h:mm A"
                                                                                      )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              event.end
                                                                                ? _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        " - "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .$moment(
                                                                                        event.end
                                                                                      )
                                                                                      .format(
                                                                                        "h:mm A"
                                                                                      )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "flex flex-col gap-1 font-outfit text-xs",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "flex flex-row items-top",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "LocationGray",
                                                                                {
                                                                                  staticClass:
                                                                                    "w-3 h-3 locationSpacing",
                                                                                }
                                                                              ),
                                                                              event.virtual &&
                                                                              event.virtual_meeting_link
                                                                                ? _c(
                                                                                    "a",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-3 text-blue-600 hover:underline font-normal",
                                                                                      attrs:
                                                                                        {
                                                                                          href: event.virtual_meeting_link,
                                                                                          target:
                                                                                            "_blank",
                                                                                          rel: "noopener noreferrer",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            event.virtual_meeting_link
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : event.location
                                                                                ? _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-3 text-primary-black font-normal",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            event.location
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-3",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "n/a"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          event.virtual &&
                                                                          event.fallback_num
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "flex items-center gap-1 text-gray-600 ml-6",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "svg",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          xmlns:
                                                                                            "http://www.w3.org/2000/svg",
                                                                                          width:
                                                                                            "12",
                                                                                          height:
                                                                                            "12",
                                                                                          viewBox:
                                                                                            "0 0 24 24",
                                                                                          fill: "none",
                                                                                          stroke:
                                                                                            "currentColor",
                                                                                          "stroke-width":
                                                                                            "2",
                                                                                          "stroke-linecap":
                                                                                            "round",
                                                                                          "stroke-linejoin":
                                                                                            "round",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "path",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-xs",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          event.fallback_num
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "flex flex-col items-top font-outfit text-xs mb-3 mt-2 font-normal",
                                                                        },
                                                                        [
                                                                          [
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "text-brown mb-1 font-normal",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Manager: "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            event.firstName
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "flex flex-row gap-2",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "flex flex-row gap-1",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "manager-chips flex flex-row items-center text-left",
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "rounded-full flex items-center text-xs flex-shrink-0 justify-center text-white uppercase manager-image hover:text-white hover:border-primary-500",
                                                                                                style:
                                                                                                  _vm.bgStyle(
                                                                                                    event
                                                                                                  ),
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      _vm.initial(
                                                                                                        event
                                                                                                      )
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  event.firstName
                                                                                                ) +
                                                                                                " " +
                                                                                                _vm._s(
                                                                                                  event.familyName
                                                                                                ) +
                                                                                                " "
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "button",
                                                                                      {
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.message(
                                                                                                event
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "ChatIcon",
                                                                                          {
                                                                                            staticClass:
                                                                                              "h-4 w-4",
                                                                                          }
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "text-xs font-normal",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " n/a "
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                          ],
                                                                        ],
                                                                        2
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "flex flex-row items-start font-outfit text-base flex-wrap gap-1",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "UIButton",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  buttonText: `Notes${
                                                                                    event.notesCount >
                                                                                    0
                                                                                      ? ` (${event.notesCount})`
                                                                                      : ""
                                                                                  }`,
                                                                                  variant:
                                                                                    "black",
                                                                                  size: "calendar",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.handleShow(
                                                                                      event
                                                                                    )
                                                                                  },
                                                                              },
                                                                            }
                                                                          ),
                                                                          event.checkOutStatus ===
                                                                            null &&
                                                                          event.checkInStatus ===
                                                                            null &&
                                                                          event.enable_visit_based_clock_ins &&
                                                                          event.accepted &&
                                                                          !event.completed
                                                                            ? _c(
                                                                                "UIButton",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      buttonText:
                                                                                        "Clock in",
                                                                                      variant:
                                                                                        "outline-black",
                                                                                      size: "calendar",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.toggleContractorClockInModal(
                                                                                          true
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                          event.checkInStatus !==
                                                                            null &&
                                                                          event.checkOutStatus ===
                                                                            null &&
                                                                          event.enable_visit_based_clock_ins &&
                                                                          event.accepted &&
                                                                          !event.completed
                                                                            ? _c(
                                                                                "UIButton",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      buttonText:
                                                                                        "Clock out",
                                                                                      variant:
                                                                                        "outline-black",
                                                                                      size: "calendar",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.toggleContractorClockInModal(
                                                                                          true
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                          event.checkOutStatus !==
                                                                            null &&
                                                                          event.checkInStatus !==
                                                                            null
                                                                            ? _c(
                                                                                "UIButton",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      buttonText:
                                                                                        "Log hours",
                                                                                      variant:
                                                                                        "outline-black",
                                                                                      size: "calendar",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      _vm.openTimeTrackerModal,
                                                                                  },
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm.showNotesModal
                                                                            ? _c(
                                                                                "NotesModal",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      isCalendarNotes: true,
                                                                                      currentUser:
                                                                                        _vm.currentUser,
                                                                                      activity:
                                                                                        _vm
                                                                                          .selectedEventNotes
                                                                                          .eventObject,
                                                                                      project:
                                                                                        _vm
                                                                                          .selectedEventNotes
                                                                                          .eventObject
                                                                                          .project,
                                                                                    },
                                                                                  on: {
                                                                                    close:
                                                                                      _vm.handleClose,
                                                                                  },
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("InfoIcon", {
                                                        staticClass: "w-3 h-3",
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "vuecal__event-title mb-4 font-normal custom-prefix",
                                              class: event.class,
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(event.status) + " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-col gap-2 vuecal__event-content",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row items-center font-outfit text-xs font-normal",
                                                },
                                                [
                                                  _c("ProfileGray", {
                                                    staticClass: "w-3 h-3",
                                                  }),
                                                  event.title
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-notification-blue ml-3 font-normal",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                event.title
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "p",
                                                        { staticClass: "ml-3" },
                                                        [_vm._v("n/a")]
                                                      ),
                                                ],
                                                1
                                              ),
                                              event.showTime
                                                ? _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-row items-center",
                                                      },
                                                      [
                                                        _c("CalendarIcon", {
                                                          staticClass:
                                                            "h-3 w-3",
                                                        }),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-xs font-normal leading-normal text-primary-black ml-3",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.createdAt(
                                                                    event
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-row items-center font-outfit text-xs leading-normal text-primary-black",
                                                      },
                                                      [
                                                        _c("ClockIcon", {
                                                          staticClass:
                                                            "w-3 h-3",
                                                        }),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "ml-3 text-xs font-normal",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$moment(
                                                                      event.start
                                                                    )
                                                                    .format(
                                                                      "h:mm A"
                                                                    )
                                                                ) +
                                                                " "
                                                            ),
                                                            event.end
                                                              ? _c("span", [
                                                                  _vm._v(" - "),
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$moment(
                                                                      event.end
                                                                    )
                                                                    .format(
                                                                      "h:mm A"
                                                                    )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-row items-top font-outfit text-xs",
                                                      },
                                                      [
                                                        _c("LocationGray", {
                                                          staticClass:
                                                            "w-3 h-3 locationSpacing",
                                                        }),
                                                        event.location
                                                          ? _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "ml-3 text-primary-black font-normal",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      event.location
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "ml-3",
                                                              },
                                                              [_vm._v("n/a")]
                                                            ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-col items-top font-outfit text-xs mb-3 font-normal",
                                                      },
                                                      [
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "text-brown mb-1 mt-2 font-normal",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Manager: "
                                                              ),
                                                            ]
                                                          ),
                                                          event.firstName
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex flex-row gap-2",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex flex-row gap-1",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "manager-chips flex flex-row items-center text-left",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "rounded-full flex items-center text-xs flex-shrink-0 justify-center text-white uppercase manager-image hover:text-white hover:border-primary-500",
                                                                              style:
                                                                                _vm.bgStyle(
                                                                                  event
                                                                                ),
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm.initial(
                                                                                      event
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                event.firstName
                                                                              ) +
                                                                              " " +
                                                                              _vm._s(
                                                                                event.familyName
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "button",
                                                                    {
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.message(
                                                                              event
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "ChatIcon",
                                                                        {
                                                                          staticClass:
                                                                            "h-4 w-4",
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "text-xs font-normal",
                                                                },
                                                                [_vm._v("n/a")]
                                                              ),
                                                        ],
                                                      ],
                                                      2
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-row items-start font-outfit text-base flex-wrap gap-1",
                                                      },
                                                      [
                                                        _c("UIButton", {
                                                          attrs: {
                                                            buttonText: `Notes${
                                                              event.notesCount >
                                                              0
                                                                ? ` (${event.notesCount})`
                                                                : ""
                                                            }`,
                                                            variant: "black",
                                                            size: "calendar",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleShow(
                                                                event
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        event.checkOutStatus ===
                                                          null &&
                                                        event.checkInStatus ===
                                                          null &&
                                                        event.enable_visit_based_clock_ins &&
                                                        event.accepted &&
                                                        !event.completed
                                                          ? _c("UIButton", {
                                                              attrs: {
                                                                buttonText:
                                                                  "Clock in",
                                                                variant:
                                                                  "outline-black",
                                                                size: "calendar",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleContractorClockInModal(
                                                                      true
                                                                    )
                                                                  },
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        event.checkInStatus !==
                                                          null &&
                                                        event.checkOutStatus ===
                                                          null &&
                                                        event.enable_visit_based_clock_ins &&
                                                        event.accepted &&
                                                        !event.completed
                                                          ? _c("UIButton", {
                                                              attrs: {
                                                                buttonText:
                                                                  "Clock out",
                                                                variant:
                                                                  "outline-black",
                                                                size: "calendar",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleContractorClockInModal(
                                                                      true
                                                                    )
                                                                  },
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        event.checkOutStatus !==
                                                          null &&
                                                        event.checkInStatus !==
                                                          null
                                                          ? _c("UIButton", {
                                                              attrs: {
                                                                buttonText:
                                                                  "Log hours",
                                                                variant:
                                                                  "outline-black",
                                                                size: "calendar",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.openTimeTrackerModal,
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm.timeTrackerModalOpened
                                                          ? _c(
                                                              "TimeTrackerModal",
                                                              {
                                                                attrs: {
                                                                  currentUserId:
                                                                    _vm
                                                                      .currentUser
                                                                      .id,
                                                                  activity:
                                                                    event.eventObject,
                                                                  tracked_date:
                                                                    event.startDate,
                                                                },
                                                                on: {
                                                                  timesChanged:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$apollo.queries.activities.refetch()
                                                                    },
                                                                  close:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.timeTrackerModalOpened = false
                                                                    },
                                                                  openRequestedHoursDeclineReasonModal:
                                                                    (time) => {
                                                                      _vm.declineReasonData =
                                                                        time
                                                                      _vm.timeTrackerModalOpened = false
                                                                      _vm.requestedHoursDeclineReasonModal = true
                                                                    },
                                                                  openDeclineReasonModal:
                                                                    (time) => {
                                                                      _vm.declineReasonData =
                                                                        time
                                                                      _vm.timeTrackerModalOpened = false
                                                                      _vm.showDeclinedReasonConversationModal = true
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.timeTrackerModalOpened,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.timeTrackerModalOpened =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "timeTrackerModalOpened",
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm.isContractorClockInModal
                                                          ? _c(
                                                              "ContractorClockInModal",
                                                              {
                                                                attrs: {
                                                                  currentUser:
                                                                    _vm.currentUser,
                                                                  activity:
                                                                    event.eventObject,
                                                                  project:
                                                                    event
                                                                      .eventObject
                                                                      .project,
                                                                },
                                                                on: {
                                                                  updateParent:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$apollo.queries.activities.refetch()
                                                                    },
                                                                  close:
                                                                    _vm.handleClockModalClose,
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm.showNotesModal
                                                          ? _c("NotesModal", {
                                                              attrs: {
                                                                isCalendarNotes: true,
                                                                currentUser:
                                                                  _vm.currentUser,
                                                                activity:
                                                                  _vm
                                                                    .selectedEventNotes
                                                                    .eventObject,
                                                                project:
                                                                  _vm
                                                                    .selectedEventNotes
                                                                    .eventObject
                                                                    .project,
                                                              },
                                                              on: {
                                                                close:
                                                                  _vm.handleClose,
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm.showModal
                                                          ? _c(
                                                              "CalendarEventModal",
                                                              {
                                                                attrs: {
                                                                  currentUser:
                                                                    _vm.currentUser,
                                                                  events:
                                                                    _vm.modalEvents,
                                                                },
                                                                on: {
                                                                  close:
                                                                    _vm.closeModal,
                                                                },
                                                              }
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "placeholder-event cursor-pointer",
                                      style: { ...event.style, width: "100%" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "moreTextDiv" },
                                        [
                                          _c("p", { staticClass: "moreText" }, [
                                            _vm._v(_vm._s(event.title)),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }